import { render, staticRenderFns } from "./BasicEducationCertificates.vue?vue&type=template&id=25a4b8aa&scoped=true&"
import script from "./BasicEducationCertificates.vue?vue&type=script&lang=js&"
export * from "./BasicEducationCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4b8aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
